(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el || el.disabled || el.getAttribute('aria-hidden') === 'true') return false;
    if (el.tabIndex < 0) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), isVisible);
  }

  function rememberOpener(el) {
    if (!el) return;
    window.__adaLastOpener = el;
    window.lastFocusedElement = el;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-drawer-options], [data-menu-drawer], [aria-controls="t4s-menu-drawer"], [data-drawer-options*="t4s-mini_cart"]');
    if (trigger) rememberOpener(trigger);
  }, true);

  function drawerCloseButton() {
    return document.querySelector('.t4s-drawer-menu__close');
  }

  function syncMenuButton(open) {
    document.querySelectorAll('[data-menu-drawer], [aria-controls="t4s-menu-drawer"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var closeBtn = drawerCloseButton();
    if (!closeBtn) return;
    if (open) {
      closeBtn.removeAttribute('tabindex');
      closeBtn.setAttribute('aria-hidden', 'false');
    } else {
      closeBtn.setAttribute('tabindex', '-1');
      closeBtn.setAttribute('aria-hidden', 'true');
    }
  }

  function moveFocusInto(drawer) {
    if (!drawer) return;
    var closeBtn = drawer.id === 't4s-menu-drawer' ? drawerCloseButton() : null;
    var target = drawer.querySelector('.t4s-drawer__close, [data-drawer-close], a[href], button:not([disabled]), input:not([type="hidden"])');
    if (drawer.id === 't4s-menu-drawer') {
      target = drawer.querySelector('a[href], button:not([disabled])') || closeBtn;
    }
    if (target) target.focus();
  }

  function watchDrawer(drawer) {
    if (!drawer || drawer.__adaWatch) return;
    drawer.__adaWatch = true;
    if (!drawer.getAttribute('role')) drawer.setAttribute('role', 'dialog');
    if (!drawer.getAttribute('aria-modal')) drawer.setAttribute('aria-modal', 'true');
    if (!drawer.getAttribute('aria-label') && !drawer.getAttribute('aria-labelledby')) {
      drawer.setAttribute('aria-label', drawer.id === 't4s-menu-drawer' ? 'Menu' : 'Shopping cart');
    }
    var open = drawer.getAttribute('aria-hidden') === 'false';
    if (drawer.id === 't4s-menu-drawer') syncMenuButton(open);

    new MutationObserver(function () {
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if (drawer.id === 't4s-menu-drawer') syncMenuButton(isOpen);
      if (isOpen && !drawer.__adaWasOpen) {
        drawer.__adaWasOpen = true;
        window.setTimeout(function () { moveFocusInto(drawer); }, 60);
      }
      if (!isOpen && drawer.__adaWasOpen) {
        drawer.__adaWasOpen = false;
        window.setTimeout(function () {
          if (window.adaRestoreFocus) window.adaRestoreFocus();
          else if (typeof adaRestoreFocus === 'function') adaRestoreFocus();
        }, 30);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  }

  function trapTab(event) {
    if (event.key !== 'Tab') return;
    var open = document.querySelector('#t4s-mini_cart[aria-hidden="false"], #t4s-menu-drawer[aria-hidden="false"]');
    if (!open) return;
    var nodes = focusables(open);
    if (open.id === 't4s-menu-drawer') {
      var closeBtn = drawerCloseButton();
      if (closeBtn && nodes.indexOf(closeBtn) === -1) nodes.push(closeBtn);
    }
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function labelRatings(root) {
    (root || document).querySelectorAll('.recommendation-rating-wrap, .t4s-product-rating, .jdgm-prev-badge, .jdgm-widget, .figma-star-rating, .product-rating, .star-rating').forEach(function (el) {
      if (el.getAttribute('aria-label') && el.getAttribute('aria-label').indexOf('5 out of 5') === -1) return;
      var score = el.getAttribute('data-average-rating');
      var count = el.getAttribute('data-number-of-reviews');
      if (!score) {
        var match = clean(el.textContent).match(/(\d+(?:\.\d+)?)/);
        score = match ? match[1] : '';
      }
      if (!count) {
        var countMatch = clean(el.textContent).match(/\(([\d,]+)\)/);
        count = countMatch ? countMatch[1] : '';
      }
      if (!score) return;
      var label = 'Rated ' + score + ' out of 5 stars';
      if (count) label += ', ' + count + ' reviews';
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', label);
    });
  }

  function labelAddToCart(root) {
    (root || document).querySelectorAll('[name="add"], [data-action-atc], .t4s-pr-addtocart, .recommendation-add-button, .product-add-button, .plp-card__atc').forEach(function (btn) {
      var existing = btn.getAttribute('aria-label') || '';
      if (existing.indexOf(',') !== -1) return;
      var action = clean(btn.textContent) || 'Add to cart';
      var name = '';
      if (btn.closest('.t4s-product-form, .t4s-sticky-atc, .t4s-product__info-container')) {
        var h1 = document.querySelector('#MainContent h1');
        name = h1 ? clean(h1.textContent) : '';
      }
      if (!name) {
        var card = btn.closest('.t4s-product, .product-card, .plp-card, .swiper-slide, .t4s-col-item');
        var titleEl = card && card.querySelector('.t4s-product-title, .plp-card__title, .recommendation-title, .product-title');
        name = titleEl ? clean(titleEl.textContent) : '';
      }
      if (!name || action.toLowerCase().indexOf(name.toLowerCase()) !== -1) return;
      btn.setAttribute('aria-label', action + ', ' + name);
    });
  }

  function labelFields(root) {
    (root || document).querySelectorAll('input, select, textarea').forEach(function (field) {
      if (field.type === 'hidden' || field.disabled) return;
      if (field.getAttribute('aria-label') || field.getAttribute('aria-labelledby') || (field.id && document.querySelector('label[for="' + field.id + '"]'))) return;
      var name = (field.getAttribute('name') || '').toLowerCase();
      var type = (field.getAttribute('type') || field.tagName).toLowerCase();
      var label = '';
      if (type === 'email' || name.indexOf('email') !== -1) label = 'Email address';
      else if (type === 'search' || name === 'q') label = 'Search';
      else if (name.indexOf('discount') !== -1 || name.indexOf('coupon') !== -1 || /coupon|discount/i.test(field.id || '')) label = 'Discount code';
      else if (name === 'id' || name.indexOf('items') !== -1) label = 'Product variant';
      else if (name.indexOf('quantity') !== -1) label = 'Quantity';
      else if (field.tagName === 'SELECT' && field.getAttribute('data-name') === 'product_type') label = 'Product type';
      if (!label) return;
      if (!field.id) field.id = 'ada-field-' + Math.random().toString(36).slice(2, 8);
      field.setAttribute('aria-label', label);
    });
  }

  function fillMissingAlt(root) {
    (root || document).querySelectorAll('img:not([alt])').forEach(function (img) {
      var card = img.closest('.t4s-product, .product-card, .plp-card, .swiper-slide, a');
      var titleEl = card && card.querySelector('.t4s-product-title, .plp-card__title, .recommendation-title, .product-title, h2, h3');
      var name = titleEl ? clean(titleEl.textContent) : '';
      img.alt = name || '';
    });
  }

  function uniqueIds() {
    var seen = Object.create(null);
    document.querySelectorAll('form[id], select[id^="product-select"], [id^="product_form"], [id^="product-form"]').forEach(function (el) {
      var id = el.id;
      if (!id) return;
      if (seen[id]) {
        var next = id + '-' + seen[id];
        while (document.getElementById(next)) {
          seen[id] += 1;
          next = id + '-' + seen[id];
        }
        seen[id] += 1;
        el.id = next;
      } else {
        seen[id] = 1;
      }
    });
  }

  function syncSubmenus(root) {
    (root || document).querySelectorAll('#t4s-menu-drawer .t4s-menu-item-has-children > a').forEach(function (link) {
      var item = link.parentElement;
      var open = item && item.classList.contains('is--opend');
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!link.getAttribute('aria-haspopup')) link.setAttribute('aria-haspopup', 'true');
    });
  }

  function carouselInstance(el) {
    if (window.jQuery) {
      var inst = window.jQuery(el).data('flickityt4s');
      if (inst) return inst;
    }
    return null;
  }

  function bindCarouselControls() {
    document.querySelectorAll('[data-ada-pause]').forEach(function (button) {
      if (button.__adaBound) return;
      var slider = button.parentElement && button.parentElement.querySelector('.flickityt4s');
      if (!slider) return;
      button.__adaBound = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setPaused(paused) {
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        button.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
      }

      function apply(paused) {
        var inst = carouselInstance(slider);
        if (!inst) return false;
        if (paused) {
          if (inst.pausePlayer) inst.pausePlayer();
          else if (inst.stopPlayer) inst.stopPlayer();
        } else if (inst.unpausePlayer) inst.unpausePlayer();
        else if (inst.playPlayer) inst.playPlayer();
        setPaused(paused);
        return true;
      }

      button.addEventListener('click', function () {
        var paused = button.getAttribute('aria-pressed') === 'true';
        apply(!paused);
      });

      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (apply(reduce) || tries > 20) window.clearInterval(timer);
      }, 300);
    });
  }

  function run(root) {
    labelRatings(root);
    labelAddToCart(root);
    labelFields(root);
    fillMissingAlt(root);
    syncSubmenus(root);
  }

  function init() {
    watchDrawer(document.getElementById('t4s-mini_cart'));
    watchDrawer(document.getElementById('t4s-menu-drawer'));
    syncMenuButton(false);
    uniqueIds();
    run(document);
    bindCarouselControls();
    document.addEventListener('keydown', trapTab);

    /* PERF: added nodes are labelled in one batched idle callback instead of synchronously per mutation */
    var pendingNodes = [];
    var flushScheduled = false;
    var schedule = window.requestIdleCallback
      ? function (cb) { window.requestIdleCallback(cb, { timeout: 300 }); }
      : function (cb) { window.setTimeout(cb, 50); };
    function flushPending() {
      flushScheduled = false;
      var nodes = pendingNodes;
      pendingNodes = [];
      nodes.forEach(function (node) {
        if (node.isConnected) run(node);
      });
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.id === 't4s-mini_cart' || node.id === 't4s-menu-drawer') watchDrawer(node);
          pendingNodes.push(node);
        });
      });
      if (pendingNodes.length && !flushScheduled) {
        flushScheduled = true;
        schedule(flushPending);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function () {
      window.setTimeout(function () { syncSubmenus(document); }, 0);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
